import { DateTime } from 'luxon';

export function isScheduledTimeWithinSafeRange(scheduledTime: Date): boolean {
    return DateTime.now() < DateTime.fromJSDate(scheduledTime).minus({ seconds: 30 });
}
